<template>
  <div>
    <!-- 其他费用编辑 -->
    <el-dialog :title="$t('message.otherFeesEdit')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1380px" center :lock-scroll="false" :modal="false">
      <div class="content">
        <!-- 配送单具体发送方式其他费用： -->
        <h6>
          {{ $t("message.otherChargesForTheSpecificDeliveryMethodOfTheDeliveryOrder") }}：
        </h6>
        <div class="table">
          <ol>
            <li class="flex03">NO</li>
            <!-- 配送单号 -->
            <li class="flex15">{{ $t("message.deliveryNoteNumber") }}</li>
            <!-- 箱号 -->
            <li>{{ $t("message.boxNO") }}</li>
            <!-- 具体发送方式 -->
            <li>{{ $t("message.specificSendingMode") }}</li>
            <!-- 收费类别 -->
            <li class="flex15">{{ $t("message.chargeType") }}</li>
            <!-- 收费名义 -->
            <li>{{ $t("message.nominalCharge") }}</li>
            <!-- 收费金额.元 -->
            <li>{{ $t("message.theAmountChargedYuan") }}</li>
            <li class="flex05" v-if="status == 22">
              {{ $t("message.delete") }}
            </li>
          </ol>
          <ul v-for="(item, index) in detail.other_price_list" :key="index">
            <li class="flex03">{{ index + 1 }}</li>
            <!-- 配送单号 -->
            <li class="flex15">
              <el-select v-model="item.porder_sn" placeholder="请选择" @change="changePorder($event, index)"
                :disabled="status != 22">
                <el-option v-for="item in boxList" :key="item.porder_sn" :label="item.porder_sn"
                  :value="item.porder_sn">
                </el-option>
              </el-select>
            </li>
            <!-- 箱号 -->
            <li>
              <el-select v-model="item.freight_id" placeholder="请选择" filterable @change="changeBox(index)"
                :disabled="status != 22">
                <el-option v-for="items in item.boxs" :key="items.id" :label="items.number" :value="items.id">
                </el-option>
              </el-select>
            </li>
            <!-- 具体发送方式 -->
            <li>
              <el-select v-model="item.logistics_id" placeholder="请选择" disabled>
                <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </li>
            <!-- 收费类别 -->
            <li class="flex15">
              <el-select v-model="item.type" placeholder="请选择" filterable :disabled="status != 22">
                <el-option v-for="item in otherFeeTypes" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </li>
            <!-- 收费名义 -->
            <li>
              <el-select v-model="item.desc" :placeholder="$t('message.nominalCharge')" filterable allow-create
                default-first-option :disabled="status != 22">
                <el-option v-for="item in descOption" :key="item.value" :label="item.value" :value="item.value">
                </el-option>
              </el-select>
            </li>
            <!-- 收费金额.元 -->
            <li>
              <el-input v-model="item.fee" :placeholder="$t('message.theAmountChargedYuan')" :disabled="status != 22"
                type="number"></el-input>
            </li>
            <li class="flex05" v-if="status == 22">
              <el-button size="small" type="primary" class="dark" @click="delItem(index)">{{ $t("message.delete")
              }}</el-button>
            </li>
          </ul>
          <!-- 新增 -->
          <div class="add" v-if="status == 22">
            <el-button size="small" type="success" @click="addItem">
              {{ $t("message.add") }}
            </el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="status == 22">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="setPorderOtherFee" v-if="isAuth(250)">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      dialogVisible: false,
      otherFeeTypes: [],
      list: [],
      boxs: [],
      descOption: [{ value: '大型荷物の追加費用' }, { value: '離島配送の追加費用' }, { value: '電池付き荷物の追加費用' }, { value: '其他' }, { value: 'RCEP' },]

    };
  },
  computed: {
    ...mapState({
      boxList: (state) => state.porderDetail.boxList,
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.porderDetail.detail,
      status: (state) => state.porderDetail.status,
    }),
  },
  created() {
    // setPorderOtherFee
    this.$api.porderApi.otherFeeTypes().then((res) => {
      this.otherFeeTypes = res.data;
    });
  },
  methods: {
    // 新增
    addItem() {
      this.detail.other_price_list.push({
        porder_sn: "",
        logistics_id: "",
        type: "",
        desc: "",
        fee: "",
        freight_id: "",
        boxs: [],
      });
    },
    //删除
    delItem(i) {
      this.detail.other_price_list.splice(i, 1);
    },
    // 配送单下的箱子
    changePorder(e, i) {
      let itemData = this.detail.other_price_list[i];
      itemData.boxs = [];
      this.boxList.forEach((item) => {
        if (item.porder_sn == e) {
          item.group.forEach((items) => {
            itemData.boxs = [...itemData.boxs, ...items.list];
          });
        }
      });
      this.$forceUpdate();
    },
    //箱子获取物流方式
    changeBox(i) {
      let itemData = this.detail.other_price_list[i];
      itemData.logistics_id = itemData.boxs.find(
        (item) => item.id == itemData.freight_id
      ).logistics_id;
    },
    // 保存
    setPorderOtherFee() {
      let datas = {
        porder_sn: this.porder_sn,
        list: this.detail.other_price_list ? this.detail.other_price_list : '',
      };
      this.$api.porderApi.setPorderOtherFee(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
        this.$store.commit("setBoxIds", []);
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.detail.other_price_list.forEach((item, index) => {
          if (item.porder_sn) {
            this.changePorder(item.porder_sn, index);
          }
          // 箱子id转换号
          this.changeBox(index)
        });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  h6 {
    margin-bottom: 20px;
    font-size: 18px;
  }

  li {
    margin-right: 20px;

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  margin: 0px 15px;

  .flex03 {
    flex: 0.3;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .add {
    margin-top: 20px;
  }
}

/deep/.el-select .el-input__inner {
  background-color: #fff !important;
  color: #606266;
}

/deep/ .el-input__inner {
  background-color: #fff !important;
  color: #606266 !important;
}
</style>